// extracted by mini-css-extract-plugin
export default {"container":"he2Q5btFxfA_TfqHQ_pn","tab":"qcnOKfSP58mity0XyrtO"};